/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ContactRequestTypeEnum = {
    bug: 'bug',
    feature: 'feature',
    general: 'general',
    question: 'question'
};
/**
 * Check if a given object implements the ContactRequest interface.
 */
export function instanceOfContactRequest(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('subject' in value) || value['subject'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function ContactRequestFromJSON(json) {
    return ContactRequestFromJSONTyped(json, false);
}
export function ContactRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brand': json['brand'] == null ? undefined : json['brand'],
        'email': json['email'],
        'includeSysInfo': json['includeSysInfo'] == null ? undefined : json['includeSysInfo'],
        'message': json['message'],
        'name': json['name'],
        'subject': json['subject'],
        'type': json['type'],
    };
}
export function ContactRequestToJSON(json) {
    return ContactRequestToJSONTyped(json, false);
}
export function ContactRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brand': value['brand'],
        'email': value['email'],
        'includeSysInfo': value['includeSysInfo'],
        'message': value['message'],
        'name': value['name'],
        'subject': value['subject'],
        'type': value['type'],
    };
}
